import React from 'react';
import { NavLink, useParams } from 'react-router-dom';

export default function AdminSidebar() {
  const { tenantId } = useParams();

  return (
    <aside className="w-64 h-screen bg-[#1e293b] text-white fixed top-0 left-0 shadow-lg z-40">
      {/* 🔹 Header */}
      <div className="p-6 text-xl font-bold border-b border-gray-700">Talentraxion Admin</div>

      {/* 🔹 Navigation */}
      <nav className="flex flex-col p-4 space-y-4 text-sm">
        <NavLink
          to={tenantId ? `/admin/tenant/${tenantId}/dashboard` : '/admin'}
          className={({ isActive }) =>
            `transition-colors duration-200 ${
              isActive ? 'text-yellow-400 font-semibold' : 'hover:text-yellow-300'
            }`
          }
        >
          Dashboard
        </NavLink>

        <NavLink
          to="/admin/panel"
          className={({ isActive }) =>
            `transition-colors duration-200 ${
              isActive ? 'text-yellow-400 font-semibold' : 'hover:text-yellow-300'
            }`
          }
        >
          Admin Panel
        </NavLink>
      </nav>
    </aside>
  );
}
